import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Logout = () => {
  const { logout, isAuth } = useAuth();
  const navigate = useNavigate();
  const [hasAttemptedLogout, setHasAttemptedLogout] = useState(false);

  useEffect(() => {
    if (isAuth && !hasAttemptedLogout) {
      (async () => {
        setHasAttemptedLogout(true);
        try {
          const result = await logout();
          if (result.success) {
            navigate("/login");
          } else {
            console.error("Logout failed");
            navigate("/login");
          }
        } catch (e) {
          console.log("logout not working", e);
          navigate("/login");
        }
      })();
    } else if (!isAuth) {
      navigate("/login");
    }
  }, [logout, navigate, isAuth, hasAttemptedLogout]);

  return <div>Logging out...</div>;
};

export default Logout;
